import { theme } from '@/design-system';

import type { ActivityKindKey } from './team-trends';

/**
 * The design system has no categorical data palette, so the four kinds borrow non-status hues.
 * In this order every adjacent pair stays apart under colour-blind simulation and each clears 3:1
 * on the chart surface; stacked segments touch in this order, so keep it.
 */
export const KIND_COLORS: Record<ActivityKindKey, string> = {
  calls: theme.colors.accent.solid,
  messages: theme.colors.orange.solid,
  meetings: theme.colors.brand.solid,
  notes: theme.colors.info.solid,
};

/** One brand hue, dark to light with magnitude; level 0 is "no activity". */
export const HEAT_COLORS = [
  theme.colors.background.overlay,
  theme.colors.brand.muted,
  theme.colors.brand.active,
  theme.colors.brand.hover,
  theme.colors.brand.solid,
] as const;

export const CHART_SURFACE = theme.colors.background.raised;
export const CHART_GRID = theme.colors.border.subtle;
export const CHART_AXIS_TEXT = theme.colors.text.secondary;
export const CHART_REFERENCE = theme.colors.text.tertiary;
export const SINGLE_SERIES_COLOR = theme.colors.brand.solid;
